<script lang="ts">
    import type { Setting, SettingsLayoutGroup } from "..";
    import LayoutComp from "./LayoutComp.svelte";
    import { createFilterExclude } from "../createFilter";

    export let layout: SettingsLayoutGroup;

    export let settings: Setting[];

    const filter = createFilterExclude();
</script>

<!----------------------------------------------------------------------------->

<div>
    <h3 use:filter>{layout.name}</h3>

    {#each layout.settings as setting}
        <LayoutComp layout={setting} {settings} />
    {/each}
</div>

<!----------------------------------------------------------------------------->

<style>
    div {
        display: grid;
        grid-template-columns: max-content 1fr;
        row-gap: 0.25rem;

        margin-left: 1rem;
        grid-column: span 2;
    }

    h3 {
        color: var(--t400);
        margin: 0 0 0 -1rem;
        display: flex;
        grid-column: span 2;
        font-size: 1rem;
        font-weight: 600;
        padding: 0.125rem 0.5rem;
    }

    h3::after {
        content: "";
        flex: 1;
        border-bottom: 1px solid currentColor;
        margin: auto 0.5rem;
    }
</style>
